// extracted by mini-css-extract-plugin
module.exports = {"banner":"cascadeInfoBanner_banner__HdaFJ","icon":"cascadeInfoBanner_icon__3xb-x","text":"cascadeInfoBanner_text__2wRhP","link":"cascadeInfoBanner_link__2rA1b"};